import * as Cookies from "es-cookie";

export default class CookieUtil {
  static set(key, value) {
    Cookies.set(key, value, {
      secure: true,
      sameSite: "strict",
    });
  }

  static get(key) {
    return Cookies.get(key);
  }

  static remove(key) {
    Cookies.remove(key);
  }
}
